import React, { useState } from "react";
import { FaPlus, FaTrashAlt } from "react-icons/fa";
import { useForm } from "react-hook-form";
import axios from "axios";
import Swal from "sweetalert2";
import { FaTh } from "react-icons/fa";
import { BiSolidPlaneAlt } from "react-icons/bi";
import { createRoot } from "react-dom/client";
import "./form.css";
import { Modal, Spinner } from "react-bootstrap";

function ParcialForm({ master, merchandise_types, years, goBack }) {

  const [formErrors, setFormErrors] = useState({});
  const [rowsh, setRowsh] = useState([])
  const [error, setError] = useState("");
  const [formData, setFormData] = useState({
    piezas: "",
    grossWeight: "",
    chargeableWeight: "",
    volumen: "",
    tipo: 1,
    descripcion: "",
  });
  const [loading, setLoading] = useState(false);

  const handleInputChange = (field, value) => {
    setFormData({ ...formData, [field]: value });

    if (formErrors[field]) {
      setFormErrors({ ...formErrors, [field]: "" });
    }
  };

  const addRowHBS = () => {
    setRowsh([
      ...rowsh,
      {
        hbs: "",
        piezas: "",
        grossWeight: "",
        chargeableWeight: "",
        volumen: "",
        tipoMercancia: "",
        descripcion: "",
        vuelos: [],
        naturaleza: {},
      }
    ]);
  };

  const removeRowHBS = (index) => {
    const updated = rowsh.filter((_, i) => i !== index);
    setRowsh(updated);
  }

  const openFlights = (index) => {
    const currentYear = new Date().getFullYear();
    const yearOptions = Array.from(
      { length: currentYear - 2019 + 2 },
      (_, i) => 2019 + i
    );

    const house = rowsh[index];

    // Filtrar vuelos correspondientes a la house seleccionada

    Swal.fire({
      title: `HOUSE: ${house.hbs}`,
      html: `
        <div class="container-fluid">
          <div style="margin-top: 1rem; width: 100%;">
            <table id="dynamicTable" class="table fondo-headUPD text-center">
              <thead class="table-light">
                <tr>
                  <th>Vuelo</th>
                  <th>Año</th>
                  <th>Hora Vuelo</th>
                  <th>Eliminar</th>
                </tr>
              </thead>
              <tbody id="tableBody"></tbody>
            </table>
            <div class="text-center">
              <button type="button" id="addRowBtn" class="btn btn-sm btn-dark">
                <span id="plusIcon"></span>
              </button>
            </div>
                      <div class="col-12 mb-2">
      <div id="error-normal" class="text-danger mt-2 alert alert-danger text-left d-none"></div>
    </div>
          </div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Guardar",
      cancelButtonText: "Cancelar",
      customClass: {
        popup: "form-alert-popup",
        confirmButton: "btn-amc-blue",
        cancelButton: "btn-amc-pink",
        title: 'swal-title-left'
      },
      didOpen: () => {

        const plusIcon = document.getElementById("plusIcon");
        if (plusIcon) createRoot(plusIcon).render(<FaPlus style={{ color: "white" }} />);

        const tableBody = document.getElementById("tableBody");
        const addRowBtn = document.getElementById("addRowBtn");

        // Función para agregar fila (puede recibir datos iniciales)
        const addRow = (flight = { flight: "", year: currentYear, time: "00:00" }) => {
          const row = document.createElement("tr");
          const uid = `trash-${Date.now()}-${Math.random()}`;

          row.innerHTML = `
        <td><input type="text" class="form-control form-control-sm text-center flight-input" name="house_flight[]" value="${flight.flight}" /></td>
        <td>
          <select class="form-select form-select-sm" name="house_year[]">
            ${yearOptions.map(y => `<option value="${y}" ${y === flight.year ? "selected" : ""}>${y}</option>`).join("")}
          </select>
        </td>
        <td><input type="time" class="form-control form-control-sm text-center" name="house_time[]" value="${flight.time}" /></td>
        <td>
          <button type="button" class="btn btn-white btn-sm deleteRowBtn">
            <span id="${uid}"></span>
          </button>
        </td>
      `;

          tableBody.appendChild(row);

          // Renderizar ícono de basura
          const trashIcon = document.getElementById(uid);
          if (trashIcon) createRoot(trashIcon).render(<FaTrashAlt style={{ color: "red" }} />);

          row.querySelector(".deleteRowBtn").addEventListener("click", () => row.remove());

          const flightInput = row.querySelector(".flight-input");

          flightInput.addEventListener("input", (e) => {
            e.target.value = e.target.value.toUpperCase(); // solo mayúsculas
          });

          // Formatea al salir
          flightInput.addEventListener("blur", (e) => {
            let value = e.target.value.toUpperCase();
            if (!value) return;

            let data = value.split("/");
            let prefix = data[0].substring(0, 2);
            let rest = data[0].substring(2);

            if (prefix === "AM") {
              if (rest.length === 1) rest = "000" + rest;
              else if (rest.length === 2) rest = "00" + rest;
              else if (rest.length === 3) rest = "0" + rest;
              else if (rest.length >= 4) rest = rest.substring(0, 4);

              const flightFormatted = "AM" + rest;

              if (data[1] === undefined || data[1] === "") {
                value = `${flightFormatted}/`;
              } else {
                value = `${flightFormatted}/${data[1]}`;
              }
            }

            e.target.value = value;
          });
        };

        // Agregar filas existentes de vuelos
        if (house.vuelos) house.vuelos.forEach(v => addRow(v));


        addRowBtn.addEventListener("click", () => addRow());
      },
      preConfirm: () => {
        const vuelos = [];
        let hasError = false;
      
        const flightRegex = /^AM\d{4}\/(0[1-9]|[12][0-9]|3[01])(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)$/;
        const errorDiv = document.getElementById("error-normal");
      
        // Limpia errores
        if (errorDiv) {
          errorDiv.classList.add("d-none");
          errorDiv.innerHTML = "";
        }
      
        const vuelosInvalidos = [];
        const filasIncompletas = [];
        const vuelosDuplicados = [];
        const vuelosSet = new Set();
      
        document.querySelectorAll("#tableBody tr").forEach((tr, i) => {
          const flightInput = tr.children[0].querySelector("input").value;
          const yearSelected = tr.children[1].querySelector("select").value;
          const timeInput = tr.children[2].querySelector("input").value;
      
          const flight = flightInput.trim().toUpperCase();
          const year = Number(yearSelected);
          const time = timeInput;
      
          // Campos obligatorios
          if (!flight || !year || !time) {
            filasIncompletas.push(i + 1);
            return;
          }
      
          // Formato inválido
          if (!flightRegex.test(flight)) {
            vuelosInvalidos.push(flight);
            return;
          }

            if (vuelosSet.has(flight)) {
      vuelosDuplicados.push(flight);
      return;
    }
    vuelosSet.add(flight)
      
          vuelos.push({
            flight,
            year,
            time,
          });
        });
      
      // 1️⃣ Campos incompletos
    if (filasIncompletas.length > 0) {
      errorDiv.innerHTML = `• Todos los campos son obligatorios en filas: ${filasIncompletas.join(", ")}`;
      errorDiv.classList.remove("d-none");
      return false;
    }

    // 2️⃣ Formato inválido
    if (vuelosInvalidos.length > 0) {
      errorDiv.innerHTML = `• Formato inválido de vuelo: ${vuelosInvalidos.join(", ")} (ej. AM0001/10MAY)`;
      errorDiv.classList.remove("d-none");
      return false;
    }

    // 3️⃣ Duplicados
    if (vuelosDuplicados.length > 0) {
      errorDiv.innerHTML = `• Vuelos duplicados: ${vuelosDuplicados.join(", ")}`;
      errorDiv.classList.remove("d-none");
      return false;
    }
      
        // ✅ Todo OK
        return vuelos;
      }
      
    }).then((result) => {
      if (result.isConfirmed) {
        const updated = [...rowsh];
        updated[index].vuelos = result.value; // Guardamos los vuelos en la house específica
        setRowsh(updated);
      }
    });
  };

  const openNatural = (index) => {
    const house = rowsh[index];
    let localData = house.naturaleza || {};

    Swal.fire({
      title: "Naturaleza y Manejo de la Carga",
      html: `<div id="nature-handling-root"></div>`,
      width: "90%",
      showCancelButton: true,
      confirmButtonText: "Guardar",
      cancelButtonText: "Cancelar",
      didOpen: () => {
        const container = document.getElementById("nature-handling-root");
        const root = createRoot(container);

        root.render(
          <NatureHandlingTable
            initialData={localData}
            onChange={(data) => {
              localData = data;
            }}
            vuelos={house.vuelos}
            house={house}
          />
        );
      },
      preConfirm: () => {
        const isChecked = (val) => val === true || val === "1" || val === 1;

        const natureChecks = [
          localData.nat_cgo,
          localData.nat_dgr,
          localData.nat_per,
          localData.nat_avi,
          localData.nat_val,
          localData.nat_hum,
          localData.nat_dip,
          localData.nat_nwp,
          localData.nat_mal,
          localData.nat_com,
          localData.nat_vic,
          localData.nat_pil,
        ];

        const handlingChecks = [
          localData.han_ice,
          localData.han_wet,
          localData.han_big,
          localData.han_hea,
          localData.han_hwc,
          localData.han_col,
          localData.han_fro,
        ];

        const hasNatureSelected = natureChecks.some(isChecked);
        const hasHandlingSelected = handlingChecks.some(isChecked);

        if (!hasNatureSelected || !hasHandlingSelected) {
          Swal.showValidationMessage("Debes seleccionar al menos una naturaleza y un manejo de la carga");
          return false;
        }

        const requireIfChecked = (check, fields, label) => {
        
          if (isChecked(check)) {
            const hasMissing = fields.some((f) => {
              const value = localData[f];
             
              return value === undefined || value === "" || value === null;
            });
        
            if (hasMissing) {
              Swal.showValidationMessage(`${label}: piezas y peso son requeridos`);
              return false;
            }
          }
        };
        

        // 🔹 NATURALEZA
        requireIfChecked(localData.nat_cgo, ["nat_cgo_pieces", "nat_cgo_weight"], "CGO");
        requireIfChecked(localData.nat_dgr, ["nat_dgr_pieces", "nat_dgr_weight"], "DGR");
        requireIfChecked(localData.nat_per, ["nat_per_pieces", "nat_per_weight"], "PER");
        requireIfChecked(localData.nat_avi, ["nat_avi_pieces", "nat_avi_weight"], "AVI");
        requireIfChecked(localData.nat_val, ["nat_val_pieces", "nat_val_weight"], "VAL");
        requireIfChecked(localData.nat_hum, ["nat_hum_pieces", "nat_hum_weight"], "HUM");
        requireIfChecked(localData.nat_dip, ["nat_dip_pieces", "nat_dip_weight"], "DIP");
        requireIfChecked(localData.nat_nwp, ["nat_nwp_pieces", "nat_nwp_weight"], "NWP");
        requireIfChecked(localData.nat_mal, ["nat_mal_pieces", "nat_mal_weight"], "MAL");
        requireIfChecked(localData.nat_com, ["nat_com_pieces", "nat_com_weight"], "COM");
        requireIfChecked(localData.nat_vic, ["nat_vic_pieces", "nat_vic_weight"], "VIC");
        requireIfChecked(localData.nat_pil, ["nat_pil_pieces", "nat_pil_weight"], "PIL");

        // 🔹 MANEJO
        requireIfChecked(localData.han_ice, ["han_ice_pieces", "han_ice_weight"], "ICE");
        requireIfChecked(localData.han_wet, ["han_wet_pieces", "han_wet_weight"], "WET");
        requireIfChecked(localData.han_big, ["han_big_pieces", "han_big_weight"], "BIG");
        requireIfChecked(localData.han_hea, ["han_hea_pieces", "han_hea_weight"], "HEA");
        requireIfChecked(localData.han_hwc, ["han_hwc_pieces", "han_hwc_weight"], "HWC");

        const sumVuelos = (arr, field) =>
          arr.reduce((acc, cur) => acc + Number(cur?.[field] || 0), 0);


        const calculateGroupTotals = (prefix) => {
          return Object.keys(localData).reduce((acc, key) => {
            if (key.startsWith(prefix) && localData[key]) {
              const val = Number(localData[key]) || 0;
              if (key.endsWith("_pieces")) acc.p += val;
              if (key.endsWith("_weight")) acc.w += val;
            }
            return acc;
          }, { p: 0, w: 0 });
        };
  
        const totalNat = calculateGroupTotals("nat_");
        const totalHan = calculateGroupTotals("han_");
        
        const housePieces = Number(house.piezas || 0);
        const houseWeight = Number(house.grossWeight || 0);
  
        // Validar Naturaleza
        if (totalNat.p !== housePieces) {
          Swal.showValidationMessage(`Piezas Naturaleza no coinciden con House`);
          return false;
        }
        if (Math.abs(totalNat.w - houseWeight) > 0.01) { // Tolerancia decimal
          Swal.showValidationMessage(`Peso Naturaleza no coincide con Housee`);
          return false;
        }
  
        // Validar Manejo
        if (totalHan.p !== housePieces) {
          Swal.showValidationMessage(`Piezas Manejo no coinciden con House`);
          return false;
        }
        if (Math.abs(totalHan.w - houseWeight) > 0.01) {
          Swal.showValidationMessage(`Peso Manejo no coincide con House`);
          return false;
        }

        // 🔹 REFRI / CONGELADO → VALIDAR TABLAS
        if (isChecked(localData.han_col)) {
          const manejoPieces = Number(localData.han_col_pieces || 0);
          const manejoWeight = Number(localData.han_col_weight || 0);

          const totalVuelosPieces = sumVuelos(localData.booking_col, "pieces");
          const totalVuelosWeight = sumVuelos(localData.booking_col, "weight");
        
          if (totalVuelosPieces !== manejoPieces) {
            Swal.showValidationMessage(`REFRI: La suma de piezas en vuelos (${totalVuelosPieces}) debe ser igual a las piezas de manejo (${manejoPieces})`);
            return false;
          }
          if (Math.abs(totalVuelosWeight - manejoWeight) > 0.01) {
            Swal.showValidationMessage(`REFRI: El peso total en vuelos (${totalVuelosWeight}) debe ser igual al peso de manejo (${manejoWeight})`);
            return false;
          }
        }


        if (isChecked(localData.han_fro)) {
          const manejoPieces = Number(localData.han_fro_pieces || 0);
          const manejoWeight = Number(localData.han_fro_weight || 0);

          const totalVuelosPieces = sumVuelos(localData.booking_fro, "pieces");
          const totalVuelosWeight = sumVuelos(localData.booking_fro, "weight");
        
          if (totalVuelosPieces !== manejoPieces) {
            Swal.showValidationMessage(`CONGE: La suma de piezas en vuelos (${totalVuelosPieces}) debe ser igual a las piezas de manejo (${manejoPieces})`);
            return false;
          }
          if (Math.abs(totalVuelosWeight - manejoWeight) > 0.01) {
            Swal.showValidationMessage(`CONGE: El peso total en vuelos (${totalVuelosWeight}) debe ser igual al peso de manejo (${manejoWeight})`);
            return false;
          }
        }


        if (isChecked(localData.nat_dgr)) {
          if (localData.has_dg_exempt === undefined) {
            Swal.showValidationMessage("DGR: debes indicar si contiene DG exentas");
            return false;
          }
        }
        return localData;

      }
    }).then((res) => {
      if (res.isConfirmed) {
        const updated = [...rowsh];
        updated[index].naturaleza = res.value;
        setRowsh(updated);
      }
    });
  };

  const onlyNumbersPieces = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    e.target.value = value;
  };

  const onlyNumbers = (e) => {
    let value = e.target.value;

    // Permite solo números y punto
    value = value.replace(/[^0-9.]/g, "");

    // Evita más de un punto decimal
    const parts = value.split(".");
    if (parts.length > 2) {
      value = parts[0] + "." + parts.slice(1).join("");
    }

    e.target.value = value;
  };



  const NatureHandlingTable = ({ initialData, onChange, vuelos, house }) => {

    const { register, watch } = useForm({
      defaultValues: initialData
    });

    React.useEffect(() => {
      const subscription = watch((values) => {
        onChange(values);
      });
    
      return () => subscription.unsubscribe();
    }, [watch, onChange]);
    
    const hasCol = watch("han_col");
    const hasFro = watch("han_fro");
    const hasDgr = watch("nat_dgr");

    return (
      <>

        <div className="row mb-4">
          <div className="col-md-4">
            <label className="bold">House:</label>
            <p id="modal_hbs">{house.hbs}</p>
          </div>
          <div className="col-md-4">
            <label className="bold">Piezas House:</label>
            <p id="modal_pieces_hbs">{house.piezas}</p>
          </div>
          <div className="col-md-4">
            <label className="bold">Peso House:</label>
            <p id="modal_weight_hbs">{house.grossWeight}</p>
          </div>
        </div>



        <table className="table table-striped mt-4">
          <colgroup>
            <col style={{ width: "10%" }} />
            <col style={{ width: "20%" }} />
            <col style={{ width: "10%" }} />
            <col style={{ width: "10%" }} />
            <col style={{ width: "10%" }} />
            <col style={{ width: "20%" }} />
            <col style={{ width: "10%" }} />
            <col style={{ width: "10%" }} />
          </colgroup>
          <thead className="text-center">
            <tr>
              <th style={{ backgroundColor: "#020C41", color: "white" }}>
                NATURALEZA
              </th>
              <th style={{ backgroundColor: "#020C41", color: "white" }}></th>
              <th style={{ backgroundColor: "#020C41", color: "white" }}>
                Piezas
              </th>
              <th style={{ backgroundColor: "#020C41", color: "white" }}>
                Peso
              </th>
              <th style={{ backgroundColor: "#020C41", color: "white" }}>
                MANEJO
              </th>
              <th style={{ backgroundColor: "#020C41", color: "white" }}>
                MANEJO
              </th>
              <th style={{ backgroundColor: "#020C41", color: "white" }}>
                Piezas
              </th>
              <th style={{ backgroundColor: "#020C41", color: "white" }}>
                Peso
              </th>
            </tr>
          </thead>
          <tbody className="text-center">
            {/* Fila CGO (GENERAL) */}
            <tr className="text-start">
              <td className="text-end">CGO</td>
              <td>
                <input
                  type="checkbox"
                  {...register("nat_cgo")}
                  defaultChecked={
                    master?.preve_save?.nat_cgo === "1"
                  }
                />{" "}
                GENERAL
              </td>
              <td>
                {watch("nat_cgo") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("nat_cgo_pieces",  {
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbersPieces}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td>
                {watch("nat_cgo") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("nat_cgo_weight",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbers}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td className="text-end">ICE</td>
              <td>
                <input
                  type="checkbox"
                  {...register("han_ice",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                  defaultChecked={
                    master?.preve_save?.han_ice === "1"
                  }
                />{" "}
                HIELO-SECO
              </td>
              <td>
                {watch("han_ice") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("han_ice_pieces",{
                      shouldUnregister: false,
                      setValueAs: (v) => {
                        if (v === "") return null;
                        return v.replace(/[^0-9]/g, "");
                      },
                    })}
                    onInput={onlyNumbersPieces}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td>
                {watch("han_ice") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("han_ice_weight",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbers}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
            </tr>

            {/* Fila DGR (PELIGROSA) */}
            <tr className="text-start">
              <td className="text-end">DGR</td>
              <td>
                <input
                  type="checkbox"
                  {...register("nat_dgr",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                  defaultChecked={
                    master?.preve_save?.nat_dgr === "1"
                  }
                />{" "}
                PELIGROSA
              </td>
              <td>
                {watch("nat_dgr") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("nat_dgr_pieces",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbersPieces}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td>
                {watch("nat_dgr") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("nat_dgr_weight",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbers}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td className="text-end">WET</td>
              <td>
                <input
                  type="checkbox"
                  {...register("han_wet",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                  defaultChecked={
                    master?.preve_save?.han_wet === "1"
                  }
                />{" "}
                HÚMEDA
              </td>
              <td>
                {watch("han_wet") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("han_wet_pieces",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbersPieces}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td>
                {watch("han_wet") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("han_wet_weight",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbers}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
            </tr>

            {/* Fila PER (PERECEDERO) */}
            <tr className="text-start">
              <td className="text-end">PER</td>
              <td>
                <input
                  type="checkbox"
                  {...register("nat_per",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                  defaultChecked={
                    master?.preve_save?.nat_per === "1"
                  }
                />{" "}
                PERECEDERO
              </td>
              <td>
                {watch("nat_per") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("nat_per_pieces",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbersPieces}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td>
                {watch("nat_per") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("nat_per_weight",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbers}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td className="text-end">BIG</td>
              <td>
                <input
                  type="checkbox"
                  {...register("han_big",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                  defaultChecked={
                    master?.preve_save?.han_big === "1"
                  }
                />{" "}
                GRANDE
              </td>
              <td>
                {watch("han_big") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("han_big_pieces",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbersPieces}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td>
                {watch("han_big") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("han_big_weight",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbers}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
            </tr>

            {/* Fila AVI (ANIMAL VIVO) */}
            <tr className="text-start">
              <td className="text-end">AVI</td>
              <td>
                <input
                  type="checkbox"
                  {...register("nat_avi",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                  defaultChecked={
                    master?.preve_save?.nat_avi === "1"
                  }
                />{" "}
                ANIMAL VIVO
              </td>
              <td>
                {watch("nat_avi") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("nat_avi_pieces",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbersPieces}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td>
                {watch("nat_avi") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("nat_avi_weight",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbers}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td className="text-end">HEA</td>
              <td>
                <input
                  type="checkbox"
                  {...register("han_hea",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                  defaultChecked={
                    master?.preve_save?.han_hea === "1"
                  }
                />{" "}
                HEAVY
              </td>
              <td>
                {watch("han_hea") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("han_hea_pieces",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbersPieces}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td>
                {watch("han_hea") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("han_hea_weight",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbers}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
            </tr>

            {/* Fila VAL (ALTO VALOR) */}
            <tr className="text-start">
              <td className="text-end">VAL</td>
              <td>
                <input
                  type="checkbox"
                  {...register("nat_val",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                  defaultChecked={
                    master?.preve_save?.nat_val === "1"
                  }
                />{" "}
                ALTO VALOR
              </td>
              <td>
                {watch("nat_val") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("nat_val_pieces",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbersPieces}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td>
                {watch("nat_val") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("nat_val_weight",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbers}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td className="text-end">HWC</td>
              <td>
                <input
                  type="checkbox"
                  {...register("han_hwc",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                  defaultChecked={
                    master?.preve_save?.han_hwc === "1"
                  }
                />{" "}
                FRAGIL
              </td>
              <td>
                {watch("han_hwc") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("han_hwc_pieces",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbersPieces}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td>
                {watch("han_hwc") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("han_hwc_weight",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbers}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
            </tr>

            {/* Fila HUM (RESTOS HUMANOS) */}
            <tr className="text-start">
              <td className="text-end">HUM</td>
              <td>
                <input
                  type="checkbox"
                  {...register("nat_hum",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                  defaultChecked={
                    master?.preve_save?.nat_hum === "1"
                  }
                />{" "}
                RESTOS HUMANOS
              </td>
              <td>
                {watch("nat_hum") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("nat_hum_pieces",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbersPieces}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td>
                {watch("nat_hum") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("nat_hum_weight",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbers}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td className="text-end">COL</td>
              <td>
                <input
                  type="checkbox"
                  {...register("han_col",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                  defaultChecked={
                    master?.preve_save?.han_col === "1"
                  }
                />{" "}
                REFRI
              </td>
              <td>
                {watch("han_col") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("han_col_pieces",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbersPieces}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td>
                {watch("han_col") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("han_col_weight",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbers}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
            </tr>

            {/* Fila DIP (VALIJA DIPLOMATICA) */}
            <tr className="text-start">
              <td className="text-end">DIP</td>
              <td>
                <input
                  type="checkbox"
                  {...register("nat_dip",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                  defaultChecked={
                    master?.preve_save?.nat_dip === "1"
                  }
                />{" "}
                VALIJA DIPLOMATICA
              </td>
              <td>
                {watch("nat_dip") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("nat_dip_pieces",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbersPieces}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td>
                {watch("nat_dip") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("nat_dip_weight",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbers}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td className="text-end">FRO</td>
              <td>
                <input
                  type="checkbox"
                  {...register("han_fro",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                  defaultChecked={
                    master?.preve_save?.han_fro === "1"
                  }
                />{" "}
                CONGELADOR
              </td>
              <td>
                {watch("han_fro") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("han_fro_pieces",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbersPieces}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td>
                {watch("han_fro") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("han_fro_weight",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbers}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
            </tr>

            {/* Fila NWP (PRENSA) */}
            <tr className="text-start">
              <td className="text-end">NWP</td>
              <td>
                <input
                  type="checkbox"
                  {...register("nat_nwp",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                  defaultChecked={
                    master?.preve_save?.nat_nwp === "1"
                  }
                />{" "}
                PRENSA
              </td>
              <td>
                {watch("nat_nwp") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("nat_nwp_pieces",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbersPieces}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td>
                {watch("nat_nwp") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("nat_nwp_weight",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbers}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td className="text-end">N/A</td>
              <td>
                <input
                  type="checkbox"
                  {...register("han_na",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                  defaultChecked={
                    master?.preve_save?.han_na === "1"
                  }
                />{" "}
                NO APLICA
              </td>
              <td>
                {watch("han_na") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("han_na_pieces",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbersPieces}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td>
                {watch("han_na") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("han_na_weight",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbers}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
            </tr>

            {/* Fila MAL (MAIL) */}
            <tr className="text-start">
              <td className="text-end">MAL</td>
              <td>
                <input
                  type="checkbox"
                  {...register("nat_mal",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                  defaultChecked={
                    master?.preve_save?.nat_mal === "1"
                  }
                />{" "}
                MAIL
              </td>
              <td>
                {watch("nat_mal") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("nat_mal_pieces",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbersPieces}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td>
                {watch("nat_mal") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("nat_mal_weight",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbers}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>

            {/* Fila COM (COMAT AM) */}
            <tr className="text-start">
              <td className="text-end">COM</td>
              <td>
                <input
                  type="checkbox"
                  {...register("nat_com",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                  defaultChecked={
                    master?.preve_save?.nat_com === "1"
                  }
                />{" "}
                COMAT AM
              </td>
              <td>
                {watch("nat_com") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("nat_com_pieces",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbersPieces}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td>
                {watch("nat_com") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("nat_com_weight",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbers}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>

            {/* Fila VIC (VALOR DECLARADO) */}
            <tr className="text-start">
              <td className="text-end">VIC</td>
              <td>
                <input
                  type="checkbox"
                  {...register("nat_vic",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                  defaultChecked={
                    master?.preve_save?.nat_vic === "1"
                  }
                />{" "}
                VALOR DECLARADO
              </td>
              <td>
                {watch("nat_vic") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("nat_vic_pieces",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbersPieces}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td>
                {watch("nat_vic") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("nat_vic_weight",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbers}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>

            {/* Fila PIL (PHARMA) */}
            <tr className="text-start">
              <td className="text-end">PIL</td>
              <td>
                <input
                  type="checkbox"
                  {...register("nat_pil",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                  defaultChecked={
                    master?.preve_save?.nat_pil === "1"
                  }
                />{" "}
                PHARMA
              </td>
              <td>
                {watch("nat_pil") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("nat_pil_pieces",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbersPieces}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td>
                {watch("nat_pil") && (
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...register("nat_pil_weight",{
                      shouldUnregister: false,
                      setValueAs: (v) => v === "" ? null : v
                    })}
                    onInput={onlyNumbers}
                    className="form-control form-control-sm"
                    
                  />
                )}
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>

        {hasCol && (
          <div className="row justify-content-center mt-4">
            <div className="col-md-8 px-0">
              <h3 className="mb-5">
                <strong>Vuelos Reservados Refri</strong>
              </h3>

              <table className="table">
                <thead>
                  <tr>
                    <th >Vuelo</th>
                    <th>Año</th>
                    <th >Hora</th>
                    <th>Piezas</th>
                    <th>Peso</th>
                  </tr>
                </thead>
                <tbody>
                  {vuelos.map((row, i) => (
                    <tr key={i}>
                      <td className="text-center" width="20%">{row.flight}</td>
                      <td className="text-center" width="20%">{row.year}</td>
                      <td className="text-center" width="20%">{row.time}</td>
                      <td className="text-center" width="20%">
                        <input
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          className="form-control form-control-sm"
                          {...register(`booking_col.${i}.pieces`)}
                          onInput={onlyNumbersPieces}
                          
                        />
                      </td>
                      <td className="text-center" width="20%">
                        <input
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          className="form-control form-control-sm"
                          {...register(`booking_col.${i}.weight`)}
                          onInput={onlyNumbers}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {hasFro && (
          <div className="row justify-content-center mt-4">
            <div className="col-md-8 px-0">
              <h3 className="mb-5">
                <strong>Vuelos Reservados Conge</strong>
              </h3>

              <table className="table">
                <thead>
                  <tr>
                    <th>Vuelo</th>
                    <th>Año</th>
                    <th>Hora</th>
                    <th>Piezas</th>
                    <th>Peso</th>
                  </tr>
                </thead>
                <tbody>
                  {vuelos.map((row, i) => (
                    <tr key={i}>
                      <td className="text-center" width="20%">{row.flight}</td>
                      <td className="text-center" width="20%">{row.year}</td>
                      <td className="text-center" width="20%">{row.time}</td>
                      <td className="text-center" width="20%">
                        <input
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          className="form-control form-control-sm"
                          {...register(`booking_fro.${i}.pieces`)}
                          onInput={onlyNumbersPieces}
                          
                        />
                      </td>
                      <td className="text-center" width="20%">
                        <input
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          className="form-control form-control-sm"
                          {...register(`booking_fro.${i}.weight`)}
                          onInput={onlyNumbers}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {hasDgr && (
          <div className="row mt-4">
            <div className="col-md-10 offset-md-1">
              <h4>¿Contiene DG exentas de verificación?</h4>

              <label className="me-3">
                <input type="radio" value="1" {...register("has_dg_exempt")} /> SÍ
              </label>

              <label>
                <input type="radio" value="0" {...register("has_dg_exempt")} /> NO
              </label>
            </div>
          </div>
        )}
      </>
    );
  };


  const validateRequiredFields = (fields, data) => {
    const errors = {};

    fields.forEach((field) => {
      if (
        data[field] === undefined ||
        data[field] === null ||
        data[field].toString().trim() === ""
      ) {
        errors[field] = "Este campo es obligatorio";
      }
    });

    return errors;
  };

  const handleSave = async () => {

    setLoading(true);

    const REQUIRED_MASTER_FIELDS = [
      "piezas",
      "grossWeight",
      "chargeableWeight",
      "volumen",
      "tipo",
      "fecha",
      "hora",
      "descripcion",
    ];

    const errors = validateRequiredFields(REQUIRED_MASTER_FIELDS, formData);

    if (Object.keys(errors).length > 0) {
      setLoading(false);
      setFormErrors(errors);
      return;
    }


    const totalMasterPieces = Number(formData.piezas);
    const totalMasterWeight = Number(formData.grossWeight);
    const totalMasterChargeable = Number(formData.chargeableWeight);

    // 1. Validar que exista al menos una House
    if (rowsh.length === 0) {
      setLoading(false);
      setError("Error, se debe agregar mínimo una house para continuar");
      return;
    }

    // 2. Sumar totales de las Houses
    let sumPieces = 0, sumWeight = 0, sumChargeable = 0;
    let hasMissingData = false;
    let hasMissingFlights = false;

    rowsh.forEach((house) => {
      sumPieces += Number(house.piezas || 0);
      sumWeight += Number(house.grossWeight || 0);
      sumChargeable += Number(house.chargeableWeight || 0);

      // Validar Naturaleza (Debe tener valores en su objeto)
      if (!house.naturaleza || Object.keys(house.naturaleza).length === 0) {
        hasMissingData = true;
      }
      // Validar Vuelos
      if (!house.vuelos || house.vuelos.length === 0) {
        hasMissingFlights = true;
      }
    });

    // 3. Validaciones de Coincidencia
    if (sumPieces !== totalMasterPieces || sumWeight !== totalMasterWeight || sumChargeable !== totalMasterChargeable) {
      setLoading(false);
      setError("Error, las piezas y peso de las houses no coinciden con la master");
      return;
    }

    if (hasMissingData) {
      setLoading(false);
      setError("Error, alguna de las houses no cuenta con naturaleza y/o manejo");
      return;
    }

    if (hasMissingFlights) {
      setLoading(false);
      setError("Error, alguna de las houses no cuenta con vuelos");
      return;
    }

    // 4. Construir Payload para el Backend (Formato Listas)
    try {
      const payload = {
        type: 3,
        awb: master.master,

        pieces: toNumberString(formData.piezas),
        weight: toNumberString(formData.grossWeight),
        chargeable_weight: toNumberString(formData.chargeableWeight),
        volume: toNumberString(formData.volumen),
        merchandise_type: Number(formData.tipo),
        description: formData.descripcion,
        reception_date: formData.fecha,
        reception_time: formData.hora,

        // ===== HOUSES =====
        house_hbs: rowsh.map(h => h.hbs),
        house_pieces: rowsh.map(h => toNumberString(h.piezas)),
        house_weight: rowsh.map(h => toNumberString(h.grossWeight)),
        house_chargeable_weight: rowsh.map(h => toNumberString(h.chargeableWeight)),
        house_volume: rowsh.map(h => toNumberString(h.volumen)),
        house_merchandise_type: rowsh.map(h => Number(h.tipoMercancia)),
        house_description: rowsh.map(h => h.descripcion),

        // ===== VUELOS =====
        flight: rowsh.map(h => joinByComma(h.vuelos, "flight")),
        year: rowsh.map(h => joinByComma(h.vuelos, "year")),
        time: rowsh.map(h => joinByComma(h.vuelos, "time")),

      };

      // COL
      // COL
      payload.col_pieces = rowsh.map(house =>
        house.naturaleza?.han_col_pieces ? String(house.naturaleza.han_col_pieces) : "0"
      );
      payload.col_weight = rowsh.map(house =>
        house.naturaleza?.han_col_weight ? String(house.naturaleza.han_col_weight) : "0"
      );

      // FRO
      payload.fro_pieces = rowsh.map(house =>
        house.naturaleza?.han_fro_pieces ? String(house.naturaleza.han_fro_pieces) : "0"
      );
      payload.fro_weight = rowsh.map(house =>
        house.naturaleza?.han_fro_weight ? String(house.naturaleza.han_fro_weight) : "0"
      );

      // ==================
      // NATURALEZA - PIEZAS
      // ==================
      payload.hbs_nat_cgo_pieces = rowsh.map(h => h.naturaleza?.nat_cgo_pieces || "0");
      payload.hbs_nat_dgr_pieces = rowsh.map(h => h.naturaleza?.nat_dgr_pieces || "0");
      payload.hbs_nat_per_pieces = rowsh.map(h => h.naturaleza?.nat_per_pieces || "0");
      payload.hbs_nat_avi_pieces = rowsh.map(h => h.naturaleza?.nat_avi_pieces || "0");
      payload.hbs_nat_val_pieces = rowsh.map(h => h.naturaleza?.nat_val_pieces || "0");
      payload.hbs_nat_hum_pieces = rowsh.map(h => h.naturaleza?.nat_hum_pieces || "0");
      payload.hbs_nat_dip_pieces = rowsh.map(h => h.naturaleza?.nat_dip_pieces || "0");
      payload.hbs_nat_nwp_pieces = rowsh.map(h => h.naturaleza?.nat_nwp_pieces || "0");
      payload.hbs_nat_mal_pieces = rowsh.map(h => h.naturaleza?.nat_mal_pieces || "0");
      payload.hbs_nat_com_pieces = rowsh.map(h => h.naturaleza?.nat_com_pieces || "0");
      payload.hbs_nat_vic_pieces = rowsh.map(h => h.naturaleza?.nat_vic_pieces || "0");
      payload.hbs_nat_pil_pieces = rowsh.map(h => h.naturaleza?.nat_pil_pieces || "0");

      // =================
      // NATURALEZA - PESO
      // =================
      payload.hbs_nat_cgo_weight = rowsh.map(h => h.naturaleza?.nat_cgo_weight || "0");
      payload.hbs_nat_dgr_weight = rowsh.map(h => h.naturaleza?.nat_dgr_weight || "0");
      payload.hbs_nat_per_weight = rowsh.map(h => h.naturaleza?.nat_per_weight || "0");
      payload.hbs_nat_avi_weight = rowsh.map(h => h.naturaleza?.nat_avi_weight || "0");
      payload.hbs_nat_val_weight = rowsh.map(h => h.naturaleza?.nat_val_weight || "0");
      payload.hbs_nat_hum_weight = rowsh.map(h => h.naturaleza?.nat_hum_weight || "0");
      payload.hbs_nat_dip_weight = rowsh.map(h => h.naturaleza?.nat_dip_weight || "0");
      payload.hbs_nat_nwp_weight = rowsh.map(h => h.naturaleza?.nat_nwp_weight || "0");
      payload.hbs_nat_mal_weight = rowsh.map(h => h.naturaleza?.nat_mal_weight || "0");
      payload.hbs_nat_com_weight = rowsh.map(h => h.naturaleza?.nat_com_weight || "0");
      payload.hbs_nat_vic_weight = rowsh.map(h => h.naturaleza?.nat_vic_weight || "0");
      payload.hbs_nat_pil_weight = rowsh.map(h => h.naturaleza?.nat_pil_weight || "0");

      // ==================
      // MANEJO - PIEZAS
      // ==================
      payload.hbs_han_ice_pieces = rowsh.map(h => h.naturaleza?.han_ice_pieces || "0");
      payload.hbs_han_wet_pieces = rowsh.map(h => h.naturaleza?.han_wet_pieces || "0");
      payload.hbs_han_big_pieces = rowsh.map(h => h.naturaleza?.han_big_pieces || "0");
      payload.hbs_han_hea_pieces = rowsh.map(h => h.naturaleza?.han_hea_pieces || "0");
      payload.hbs_han_hwc_pieces = rowsh.map(h => h.naturaleza?.han_hwc_pieces || "0");
      payload.hbs_han_col_pieces = rowsh.map(h => h.naturaleza?.han_col_pieces || "0");
      payload.hbs_han_fro_pieces = rowsh.map(h => h.naturaleza?.han_fro_pieces || "0");
      payload.hbs_han_na_pieces = rowsh.map(h => h.naturaleza?.han_na_pieces || "0");

      // =================
      // MANEJO - PESO
      // =================
      payload.hbs_han_ice_weight = rowsh.map(h => h.naturaleza?.han_ice_weight || "0");
      payload.hbs_han_wet_weight = rowsh.map(h => h.naturaleza?.han_wet_weight || "0");
      payload.hbs_han_big_weight = rowsh.map(h => h.naturaleza?.han_big_weight || "0");
      payload.hbs_han_hea_weight = rowsh.map(h => h.naturaleza?.han_hea_weight || "0");
      payload.hbs_han_hwc_weight = rowsh.map(h => h.naturaleza?.han_hwc_weight || "0");
      payload.hbs_han_col_weight = rowsh.map(h => h.naturaleza?.han_col_weight || "0");
      payload.hbs_han_fro_weight = rowsh.map(h => h.naturaleza?.han_fro_weight || "0");
      payload.hbs_han_na_weight = rowsh.map(h => h.naturaleza?.han_na_weight || "0");

      const response = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_administrative_billing/fact_admin_data_save`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token") || ""}`,
          },
        }
      );

      if (response.data.code === 1) {
        setLoading(false);
        goBack()
        Swal.fire({
          title: "Guardado",
          text: response.data.message,
          icon: "success",
          iconColor: "#1B9925",
          customClass: {
            confirmButton: "btn-ok",
            title: "alert-title",
            popup: "alert-bg",
          },
        });
      }
    } catch (err) {
      setLoading(false);
      Swal.fire({
        title: "Error",
        text: "Ocurrió un error al guardar la información",
        icon: "error",
      });
    }
  };


  const toNumberString = (v) =>
    v === undefined || v === null || v === "" ? "0" : String(v);

  const joinByComma = (arr, key) =>
    arr.map(v => v[key]).join(",");

  return (

    <>
      <div className="row mb-4">
        {[
          { label: "Piezas Master", key: "piezas" },
          { label: "Gross Weight Master", key: "grossWeight" },
          { label: "Chargeable Weight Master", key: "chargeableWeight" },
          { label: "Volumen Master", key: "volumen" },
          { label: "Tipo de mercancia", key: "tipo" },
          { label: "Fecha recepción", key: "fecha" },
          { label: "Hora recepción", key: "hora" },
          { label: "Descripción Master", key: "descripcion" },
        ].map((item, index) => (
          <div key={index} className="col-md-4 mb-3">
            <label className="form-label fw-bold">{item.label}</label>
            {item.key === "tipo" ? (
              <>
                <select
                  className="form-select"
                  value={formData.tipo || ""}
                  onChange={(e) => handleInputChange("tipo", e.target.value)}
                >
                  <option value="">Seleccione...</option>
                  {Object.entries(merchandise_types || {}).map(([id, label]) => (
                    <option key={id} value={id}>
                      {label}
                    </option>
                  ))}
                </select>
                {formErrors.tipo && (
                  <small className="text-danger">{formErrors.tipo}</small>
                )}

              </>

            ) : item.key === "descripcion" ? (
              <>
                <textarea
                  className="form-control"
                  rows="2"
                  value={formData.descripcion || ""}
                  onChange={(e) => handleInputChange("descripcion", e.target.value)}
                />
                {formErrors.descripcion && (
                  <small className="text-danger">{formErrors.descripcion}</small>
                )}
              </>

            ) : (
              <>
                <input
                  type={item.key === "fecha" ? "date" : item.key === "hora" ? "time" : "text"}
                  className="form-control"
                  value={formData[item.key] || ""}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (item.key === "piezas") {
                      if (/^\d*$/.test(value)) {
                        handleInputChange("piezas", value);
                      }
                    } else if (
                      [
                        "grossWeight",
                        "chargeableWeight",
                        "volumen",
                      ].includes(item.key)
                    ) {
                      if (/^\d*\.?\d*$/.test(value)) {
                        handleInputChange(item.key, value);
                      }
                    } else {
                      handleInputChange(item.key, value);
                    }
                  }}
                />

                {formErrors[item.key] && (
                  <small className="text-danger">
                    {formErrors[item.key]}
                  </small>
                )}
              </>
            )}
          </div>
        ))}
      </div>

      <div className="mt-4 mb-4">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>*HBS</th>
                <th>*Piezas</th>
                <th>*Gross Weight</th>
                <th>*Chargeable Weight</th>
                <th>*Volumen</th>
                <th>*Tipo</th>
                <th>Descripción</th>
                <th width="8%"></th>
              </tr>
            </thead>
            <tbody>
              {rowsh.map((row, index) => (
                <tr key={index}>
                  <td><input type="text" className="form-control" value={row.hbs} onChange={(e) => { const u = [...rowsh]; u[index].hbs = e.target.value; setRowsh(u); }} /></td>
                  <td><input inputMode="numeric"
                    pattern="[0-9]*" className="form-control" value={row.piezas} onChange={(e) => { const onlyNumbers = e.target.value.replace(/[^0-9]/g, ""); const u = [...rowsh]; u[index].piezas = onlyNumbers; setRowsh(u); }} /></td>
                  <td><input type="text"
                    inputMode="numeric"
                    pattern="[0-9]*" className="form-control" value={row.grossWeight}  onChange={(e) => {
                      let value = e.target.value;

                      // Permite solo números y punto
                      value = value.replace(/[^0-9.]/g, "");

                      // Evita más de un punto
                      const parts = value.split(".");
                      if (parts.length > 2) {
                        value = parts[0] + "." + parts.slice(1).join("");
                      }

                      const u = [...rowsh];
                      u[index].grossWeight = value;
                      setRowsh(u);
                    }} /></td>
                  <td><input type="text"
                    inputMode="numeric"
                    pattern="[0-9]*" className="form-control" value={row.chargeableWeight} 
                    onChange={(e) => {
                      let value = e.target.value;

                      // Permite solo números y punto
                      value = value.replace(/[^0-9.]/g, "");

                      // Evita más de un punto
                      const parts = value.split(".");
                      if (parts.length > 2) {
                        value = parts[0] + "." + parts.slice(1).join("");
                      }

                      const u = [...rowsh];
                      u[index].chargeableWeight = value;
                      setRowsh(u);
                    }} /></td>
                  <td><input type="text"
                    inputMode="numeric"
                    pattern="[0-9]*" className="form-control" value={row.volumen}  onChange={(e) => {
                      let value = e.target.value;

                      // Permite solo números y punto
                      value = value.replace(/[^0-9.]/g, "");

                      // Evita más de un punto
                      const parts = value.split(".");
                      if (parts.length > 2) {
                        value = parts[0] + "." + parts.slice(1).join("");
                      }

                      const u = [...rowsh];
                      u[index].volumen = value;
                      setRowsh(u);
                    }} /></td>
                  <td>
                    <select className="form-select" value={row.tipoMercancia} onChange={(e) => { const u = [...rowsh]; u[index].tipoMercancia = e.target.value; setRowsh(u); }}>
                      <option value="">Selecciona una opción</option>
                      {Object.entries(merchandise_types || {}).map(([id, label]) => (
                        <option key={id} value={id}>
                          {label}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td><input type="text" className="form-control" value={row.descripcion} onChange={(e) => { const u = [...rowsh]; u[index].descripcion = e.target.value; setRowsh(u); }} /></td>

                  <td className="text-center">
                    <BiSolidPlaneAlt
                      size={22}
                      className="text-success me-2"
                      style={{ cursor: "pointer" }}
                      onClick={() => openFlights(index)}
                    />

                    <FaTh
                      size={22}
                      className="text-info me-2"
                      style={{ cursor: "pointer" }}
                      onClick={() => openNatural(index)}
                    />

                    <FaTrashAlt
                      size={22}
                      className="text-danger"
                      style={{ cursor: "pointer" }}
                      onClick={() => removeRowHBS(index)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="text-center mt-3">
          <button className="btnn" onClick={addRowHBS}>+</button>
        </div>
      </div>


      {error && (
        <div className="alert alert-danger text-center mt-3">
          {error}
        </div>
      )}
      <div className="row mt-4">
        <div className="col-12 text-end">
          <button type="submit" class="btn btn-primary" id="save1" onClick={handleSave}>Guardar</button>
        </div>
      </div>

      <Modal
        show={loading}
        onHide={() => setLoading(false)}
        backdrop="static"
        keyboard={false}
        centered
        dialogClassName="custom-modal"
        backdropClassName="custom-backdrop"
      >
        <div className="spinner-container">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Cargando...</span>
          </Spinner>
        </div>
      </Modal>
    </>
  );
}

export default ParcialForm;
